import React from 'react';
import { Card } from './ui/Card';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { BAY_DATA } from '../utils/mockData';
export function BayAnalytics() {
  return <Card className="h-full flex flex-col" data-id="element-58">
      <div className="mb-6 flex items-center justify-between" data-id="element-59">
        <h2 className="text-lg font-semibold text-white" data-id="element-60">
          Loading Bay Cycle Time
        </h2>
        <span className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-61">
          External View Only
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-62">
        <div className="rounded-lg bg-gray-900/50 p-4 border border-gray-800" data-id="element-63">
          <div className="text-xs text-gray-400 mb-1" data-id="element-64">Avg Bay Time (Today)</div>
          <div className="text-2xl font-bold text-white" data-id="element-65">42m</div>
        </div>
        <div className="rounded-lg bg-gray-900/50 p-4 border border-gray-800" data-id="element-66">
          <div className="text-xs text-gray-400 mb-1" data-id="element-67">Median Time</div>
          <div className="text-2xl font-bold text-white" data-id="element-68">38m</div>
        </div>
      </div>

      <div className="flex-1 min-h-[200px]" data-id="element-69">
        <h3 className="text-xs font-medium text-gray-400 mb-4" data-id="element-70">
          Bay Occupancy Timeline
        </h3>
        <ResponsiveContainer width="100%" height="100%" data-id="element-71">
          <BarChart data={BAY_DATA} data-id="element-72">
            <XAxis dataKey="time" stroke="#4b5563" fontSize={12} tickLine={false} axisLine={false} data-id="element-73" />
            <Tooltip contentStyle={{
            backgroundColor: '#1f2937',
            border: 'none',
            borderRadius: '8px',
            color: '#fff'
          }} cursor={{
            fill: '#374151',
            opacity: 0.4
          }} data-id="element-74" />
            <Bar dataKey="occupancy" radius={[4, 4, 0, 0]} data-id="element-75">
              {BAY_DATA.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.occupancy > 75 ? '#ef4444' : '#f59e0b'} data-id="element-76" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>;
}